/* Totie: interacción de las secciones propias. Se carga con defer y cada bloque se inicia una sola vez. */
(function () {
  function once(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  function init(root) {
    // Comparador antes y después
    root.querySelectorAll('.tt .cmp input[type=range]').forEach(function (r) {
      if (!once(r, 'ttCmp')) return;
      r.addEventListener('input', function () { r.parentNode.style.setProperty('--p', r.value + '%'); });
    });

    // Comparador grande: una clienta a la vez
    root.querySelectorAll('[data-tt-res]').forEach(function (box) {
      if (!once(box, 'ttRes')) return;
      var btns = box.querySelectorAll('[data-who]');
      var cmp = box.querySelector('.cmp');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
          cmp.querySelector('.before').src = b.dataset.before;
          cmp.querySelector('.before').srcset = '';
          cmp.querySelector('.after').src = b.dataset.after;
          cmp.querySelector('.after').srcset = '';
          cmp.style.aspectRatio = b.dataset.ratio;
          cmp.style.setProperty('--p', '50%');
          cmp.querySelector('input').value = 50;
          box.querySelector('[data-who-name]').textContent = b.dataset.name;
          box.querySelector('[data-who-w]').textContent = b.dataset.w;
        });
      });
    });

    // Rejilla de resultados: en el celular una clienta a la vez
    root.querySelectorAll('[data-tt-grid]').forEach(function (box) {
      if (!once(box, 'ttGrid')) return;
      var btns = box.querySelectorAll('[data-card]');
      btns.forEach(function (b) {
        if (b.classList.contains('rcard')) return;
        b.addEventListener('click', function () {
          box.querySelectorAll('.rcard').forEach(function (c) { c.classList.toggle('on', c.dataset.card === b.dataset.card); });
          btns.forEach(function (o) { if (!o.classList.contains('rcard')) o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        });
      });
    });

    // Pestañas del producto
    root.querySelectorAll('.tt .tablist').forEach(function (list) {
      if (!once(list, 'ttTabs')) return;
      var tabs = list.querySelectorAll('[role=tab]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (o) {
            var on = o === t;
            o.setAttribute('aria-selected', on ? 'true' : 'false');
            document.getElementById(o.getAttribute('aria-controls')).hidden = !on;
          });
        });
      });
    });

    // Galería del producto en computador: miniaturas, flechas, contador y teclado
    root.querySelectorAll('[data-tt-gal]').forEach(function (gal) {
      if (!once(gal, 'ttGal')) return;
      var thumbs = gal.querySelectorAll('[data-slide]');
      var slides = gal.querySelectorAll('.main > [data-idx]');
      var prev = gal.querySelector('.gal-nav.prev');
      var next = gal.querySelector('.gal-nav.next');
      var count = gal.querySelector('[data-gal-n]');
      var cur = 0;
      function show(i) {
        if (i < 0 || i >= slides.length) return;
        cur = i;
        slides.forEach(function (s, k) {
          s.hidden = k !== i;
          var v = s.querySelector('video');
          if (v) { if (k === i) { v.muted = true; v.play().catch(function () {}); } else { v.pause(); } }
        });
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
        if (count) count.textContent = i + 1;
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      if (prev) prev.addEventListener('click', function () { show(cur - 1); });
      if (next) next.addEventListener('click', function () { show(cur + 1); });
      gal.tabIndex = -1;
      gal.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') show(cur - 1);
        if (e.key === 'ArrowRight') show(cur + 1);
      });
      show(0);
    });

    // Carrusel del celular: se desliza con el dedo, con flechas y con los puntos
    root.querySelectorAll('[data-tt-mcar]').forEach(function (car) {
      if (!once(car, 'ttCar')) return;
      var track = car.querySelector('.mtrack');
      var dots = car.querySelectorAll('.mdots button');
      var prev = car.querySelector('.gal-nav.prev');
      var next = car.querySelector('.gal-nav.next');
      var n = track.children.length;
      function idx() { return Math.round(track.scrollLeft / track.clientWidth); }
      function go(i) { i = Math.max(0, Math.min(n - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
      function update() {
        var i = idx();
        dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i >= n - 1;
        Array.prototype.forEach.call(track.children, function (el, k) {
          if (el.tagName === 'VIDEO') { if (k === i) { el.muted = true; el.play().catch(function () {}); } else { el.pause(); } }
        });
      }
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.go, 10)); }); });
      if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
      if (next) next.addEventListener('click', function () { go(idx() + 1); });
      track.addEventListener('scroll', update, { passive: true });
      update();
    });

    // Fila de videos: flechas, puntos y arrastre con el mouse
    root.querySelectorAll('[data-tt-reel]').forEach(function (wrap) {
      if (!once(wrap, 'ttReel')) return;
      var reel = wrap.querySelector('.reel');
      var clips = reel.querySelectorAll('.clip');
      var dots = wrap.querySelectorAll('.reel-dots span');
      var prev = wrap.querySelector('.prev');
      var next = wrap.querySelector('.next');
      function step() { return clips.length > 1 ? clips[1].offsetLeft - clips[0].offsetLeft : reel.clientWidth; }
      function update() {
        var max = reel.scrollWidth - reel.clientWidth - 4;
        wrap.classList.toggle('fits', max <= 0);
        prev.disabled = reel.scrollLeft <= 4;
        next.disabled = reel.scrollLeft >= max;
        var i = Math.round(reel.scrollLeft / step());
        if (reel.scrollLeft >= max) i = clips.length - 1;
        dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
      }
      prev.addEventListener('click', function () { reel.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { reel.scrollBy({ left: step(), behavior: 'smooth' }); });
      reel.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();

      // Arrastre con el mouse en computador (en el celular se desliza con el dedo)
      var down = false, startX = 0, startLeft = 0, moved = false;
      reel.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; startX = e.clientX; startLeft = reel.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) { moved = true; reel.classList.add('drag'); }
        reel.scrollLeft = startLeft - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        reel.classList.remove('drag');
        if (moved) {
          var end = reel.scrollWidth - reel.clientWidth;
          var i = Math.round(reel.scrollLeft / step());
          reel.scrollTo({ left: reel.scrollLeft >= end - 4 ? end : Math.min(i * step(), end), behavior: 'smooth' });
        }
      });
      reel.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });

    // Cantidad
    root.querySelectorAll('[data-tt-qty]').forEach(function (q) {
      if (!once(q, 'ttQty')) return;
      var input = q.querySelector('input');
      q.querySelector('[data-minus]').addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      q.querySelector('[data-plus]').addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    });

    // Barra fija del celular: aparece cuando el botón de compra sale de la pantalla
    root.querySelectorAll('[data-tt-sticky]').forEach(function (bar) {
      if (!once(bar, 'ttSticky')) return;
      var target = document.getElementById(bar.dataset.ttSticky);
      if (!target || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (e) {
        var show = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
        bar.classList.toggle('on', show);
        document.body.classList.toggle('tt-has-sticky', show && window.innerWidth <= 760);
      }).observe(target);
      bar.querySelector('button').addEventListener('click', function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    // Videos: solo se reproducen cuando están en pantalla
    var vids = root.querySelectorAll('.tt .clip video, .tt video[data-tt-auto]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            if (!v.src && v.dataset.ttSrc) {
              v.src = v.dataset.ttSrc;
              v.addEventListener('playing', function () { v.classList.add('on'); }, { once: true });
            }
            if (!v.src && v.dataset.ttSrcs) {
              var list = [];
              try { list = JSON.parse(v.dataset.ttSrcs); } catch (err) {}
              list.sort(function (a, b) { return a.w - b.w; });
              var need = v.clientWidth * (window.devicePixelRatio || 1);
              var pick = list[list.length - 1];
              for (var i = 0; i < list.length; i++) { if (list[i].w >= need) { pick = list[i]; break; } }
              if (pick) {
                v.src = pick.u;
                v.addEventListener('playing', function () { v.classList.add('on'); }, { once: true });
              }
            }
            v.muted = true; v.play().catch(function () {});
          } else { v.pause(); }
        });
      }, { threshold: 0.35 });
      vids.forEach(function (v) { if (once(v, 'ttVid')) io.observe(v); });
    }
  }

  // Video del hero: se baja después de que la página cargó y en el tamaño justo para la pantalla
  function heroVideo() {
    var c = navigator.connection;
    if (c && (c.saveData || /2g/.test(c.effectiveType || ''))) return;
    document.querySelectorAll('[data-tt-hero-video]').forEach(function (v) {
      if (v.dataset.ttOn) return;
      v.dataset.ttOn = '1';
      var small = window.innerWidth <= 760;
      var own = small ? v.dataset.mob : v.dataset.desk;
      if (own) {
        v.src = own;
        v.muted = true;
        v.addEventListener('playing', function () { v.classList.add('on'); }, { once: true });
        v.play().catch(function () {});
        return;
      }
      var list = [];
      try { list = JSON.parse(v.dataset.ttHeroVideo); } catch (e) { return; }
      if (!list.length) return;
      var need = Math.min(window.innerWidth * (window.devicePixelRatio || 1), window.innerWidth <= 760 ? 720 : 1920);
      list.sort(function (a, b) { return a.w - b.w; });
      var pick = list[list.length - 1];
      for (var i = 0; i < list.length; i++) { if (list[i].w >= need) { pick = list[i]; break; } }
      v.src = pick.u;
      v.muted = true;
      v.addEventListener('playing', function () { v.classList.add('on'); }, { once: true });
      v.play().catch(function () {});
    });
  }
  function afterLoad() {
    var go = function () { setTimeout(heroVideo, 100); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
  }

  function start() { init(document); afterLoad(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
